import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
interface HeroSearchProps {
  onSearch: (query: string) => void;
  onNavigate: (view: string) => void;
}
export function HeroSearch({
  onSearch,
  onNavigate
}: HeroSearchProps) {
  const [query, setQuery] = useState('');
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query);
      onNavigate('knowledge-base');
    }
  };
  const popularTags = ['Salesforce', 'VPN', 'Encompass', 'Password Reset', 'Printer'];
  return <div className="bg-gradient-to-b from-blue-50 to-white py-16 sm:py-24 border-b border-slate-100" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-49">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-50">
          How can we help you today?
        </h1>
        <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-51">
          Search our knowledge base for quick answers, or submit a support
          request to our IT team.
        </p>

        <form onSubmit={handleSearch} className="relative max-w-2xl mx-auto mb-6" data-id="element-52">
          <div className="relative flex items-center" data-id="element-53">
            <SearchIcon className="absolute left-4 w-6 h-6 text-slate-400" data-id="element-54" />
            <input type="text" className="w-full pl-12 pr-4 py-4 rounded-2xl border-0 ring-1 ring-slate-200 shadow-lg text-lg focus:ring-2 focus:ring-blue-600 focus:outline-none transition-shadow" placeholder="Search for help articles, known issues..." value={query} onChange={e => setQuery(e.target.value)} data-id="element-55" />
            <button type="submit" className="absolute right-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-colors" data-id="element-56">
              Search
            </button>
          </div>
        </form>

        <div className="flex flex-wrap justify-center gap-2 items-center text-sm text-slate-500" data-id="element-57">
          <span data-id="element-58">Popular searches:</span>
          {popularTags.map(tag => <button key={tag} onClick={() => {
          setQuery(tag);
          onSearch(tag);
          onNavigate('knowledge-base');
        }} className="px-3 py-1 bg-white border border-slate-200 rounded-full hover:bg-slate-50 hover:border-slate-300 transition-colors" data-id="element-59">
              {tag}
            </button>)}
        </div>
      </div>
    </div>;
}